import {Button} from '@components/common/button/button'
import {Popup} from '@components/common/popup/popup'
import {noPropagate} from '@containers/hooks'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {
  ActionType,
  useMultiActionsWithTasksStore
} from '../multi-actions-with-tasks-store'

const getTitle = (currentAction: ActionType): string => {
  switch (currentAction) {
    case 'archive':
      return Lang.msg.multiActionsWithTasks.noPermissionsArchive
    case 'check':
      return Lang.msg.multiActionsWithTasks.noPermissionsComplete
    case 'delete':
      return Lang.msg.multiActionsWithTasks.noPermissionDelete
    case 'move':
      return Lang.msg.multiActionsWithTasks.noPermissionsMove
    case 'unarchive':
      return Lang.msg.multiActionsWithTasks.noPermissionsUnarchive
    case 'uncheck':
      return Lang.msg.multiActionsWithTasks.noPermissionsUncheck
    default:
      return ''
  }
}

const getButton = (currentAction: ActionType): string => {
  switch (currentAction) {
    case 'archive':
      return Lang.msg.multiActionsWithTasks.archiveOnlyAvailable
    case 'check':
      return Lang.msg.multiActionsWithTasks.completeOnlyAvailable
    case 'delete':
      return Lang.msg.multiActionsWithTasks.deleteOnlyAvailable
    case 'move':
      return Lang.msg.multiActionsWithTasks.moveOnlyAvailable
    case 'unarchive':
      return Lang.msg.multiActionsWithTasks.unarchiveOnlyAvailable
    case 'uncheck':
      return Lang.msg.multiActionsWithTasks.uncheckOnlyAvailable
    default:
      return ''
  }
}

export const NoRightsToSomeTasksPopup = observer(() => {
  const [state, store] = useMultiActionsWithTasksStore()
  if (!state.noRightsToSomeTasks) {
    return null
  }
  return (
    <Popup
      title={getTitle(state.currentAction)}
      width={460}
      autoHeight
      minHeightAuto
      noPropagateOverlay
      noPropagateBody
      close={() => store.setNoRightsToSomeTasks(false)}
      contentClassName="h-full items-end flex pb-16"
    >
      <div className="flex gap-8 flex-wrap">
        <Button
          onClick={() => store.performAction()}
          $bgClassName="bg-error-old"
        >
          {getButton(state.currentAction)}
        </Button>
        <Button
          onClick={e => {
            noPropagate(e)
            store.setNoRightsToSomeTasks(false)
          }}
        >
          {Lang.msg.multiActionsWithTasks.cancel}
        </Button>
      </div>
    </Popup>
  )
})
